import { MoreAboutTheAccidentForm } from "./Form";
import { useMoreAboutTheAccident } from "./hooks/useMoreAboutTheAccident";

export const MoreAboutTheAccident = () => {
  const props = useMoreAboutTheAccident();
  return <MoreAboutTheAccidentForm {...props} />;
};

export default MoreAboutTheAccident;
